import { FC, useMemo } from "react";
import { AbsenceCategory } from "@myapp/contract";
import Select from "../../../shared/ui/controls/Select/Select";
import { absenceCategoryOptions } from "../model/absenceCategory";
import { ISelectOption } from "../../../shared/types/ISelectOption";

const ALL_OPTION: ISelectOption = { value: null, label: "Alle Kategorien" };

interface AbsenceCategorySelectProps {
  value?: AbsenceCategory | null;
  onChange?: (value: AbsenceCategory | null) => void;
  withAllOption?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  error?: string | null;
  size?: "md" | "sm";
}

const AbsenceCategorySelect: FC<AbsenceCategorySelectProps> = ({
  value,
  onChange,
  withAllOption = false,
  placeholder = "Kategorie wählen",
  className,
  disabled,
  error,
  size,
}) => {
  const options = useMemo(
    () => (withAllOption ? [ALL_OPTION, ...absenceCategoryOptions] : absenceCategoryOptions),
    [withAllOption],
  );

  return (
    <Select
      options={options}
      value={value ?? null}
      onChange={(v) => onChange?.(v as AbsenceCategory | null)}
      placeholder={placeholder}
      className={className}
      disabled={disabled}
      error={error}
      size={size}
    />
  );
};

export default AbsenceCategorySelect;
